import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toastService from '../../../../../utils/toastService';
import {
    useCreateWarrantyPeriodAsyncMutation,
    useGetWarrantyPeriodAllQuery,
    useUpdateWarrantyPeriodMutation,
    useDeleteWarrantyPeriodMutation
} from '../../../../../api';

const useWarrantyPeriodData = () => {
    const navigate = useNavigate();
    const [submitted, setSubmitted] = useState(false);
    const [lazyParams, setLazyParams] = useState({ first: 1, rows: 10, page: 1 });
    const [activeFilters, setActiveFilters] = useState({
        carItemCode: '',
        productGroup: '',
        startDate: '',
        endDate: ''
    });

    const {
        data: warrantyPeriodApi,
        isLoading,
        isFetching,
        error,
        refetch
    } = useGetWarrantyPeriodAllQuery({
        pageNumber: lazyParams.page,
        pageSize: lazyParams.rows,
        carItemCode: activeFilters.carItemCode || undefined,
        productGroup: activeFilters.productGroup || undefined,
        startDate: activeFilters.startDate || undefined,
        endDate: activeFilters.endDate || undefined
    });
    

    const [DeleteWarrantyPeriod] = useDeleteWarrantyPeriodMutation();
    const [UpdateWarrantyPeriod] = useUpdateWarrantyPeriodMutation();
    const [createWarrantyPeriodAsync] = useCreateWarrantyPeriodAsyncMutation();

    const saveWarrantyPeriod = async (data) => {
        try {
            if (data.id) {
                await UpdateWarrantyPeriod(data).unwrap();
                toastService.success('Araç garanti süresi başarıyla güncellendi');
            } else {
                await createWarrantyPeriodAsync(data).unwrap();
                toastService.success('Araç garanti süresi başarıyla eklendi');
            }
            refetch();
            return true;
        } catch (error) {
            toastService.error('Araç garanti süresi kaydedilirken bir hata oluştu');
            return false;
        }
    };
    

    const handleDelete = async (data) => {
        try {
            await DeleteWarrantyPeriod(data).unwrap();
            toastService.success('Garanti süresi başarıyla silindi');
            refetch();
            return true;
        } catch (error) {
            toastService.error('Garanti süresi silinemedi');
            return false;
        }
    };

    const handleFilterChange = (updatedFilters) => {

        const apiFilters = {
            carItemCode: updatedFilters.carItemCode || '',
            productGroup: updatedFilters.productGroup || '',
            startDate: updatedFilters.startDate || '',
            endDate: updatedFilters.endDate || ''
        };

        setActiveFilters(apiFilters);

        setLazyParams((prevParams) => ({
            ...prevParams,
            first: 0,
            page: 1
        }));
    };

    const onPage = (event) => {
        setLazyParams((prev) => ({
            ...prev,
            page: event.page + 1,
            first: event.first,
            rows: event.rows
        }));
    };

    const initFilters = () => {
        setActiveFilters({
            carItemCode: '',
            productGroup: '',
            startDate: '',
            endDate: ''
        });
        setLazyParams((prevParams) => ({
            ...prevParams,
            first: 0,
            page: 1
        }));
    };
    return {
        warrantyPeriodApi: warrantyPeriodApi || { items: [], totalCount: 0 },
        isLoading,
        isFetching,
        error,
        lazyParams,
        submitted,
         initFilters,
        handleFilterChange,
        setSubmitted,
        saveWarrantyPeriod,
        onPage,
        handleDelete
    };
};

export default useWarrantyPeriodData;